import * as React from 'react'

import { QuizType } from '../../../../../commons/EditorStatus'
import PresentationTitle from '../../PresentationTitle/PresentationTitle'
import Question from '../../Question/Question'
import RankingResult from '../../RankingResult/RankingResult'

import * as styles from './MobileEditorPreview.css'

interface MobileEditorPreviewProps {
  question?: any
  type: any
  index?: number
  eventTitle?: string
  eventImage?: string
}

const MobileEditorPreview: React.FunctionComponent<MobileEditorPreviewProps> = ({
  question,
  type,
  index,
  eventTitle,
  eventImage
}: MobileEditorPreviewProps) => {
  let content: any = ''
  switch (type) {
    case QuizType.FIRSTPAGE.value:
      content = <PresentationTitle participantCount={100} title={eventTitle} image={eventImage} shareUrl={'hoge'} />
      break
    case QuizType.QUESTION.value:
      content = <Question question={question} index={index || 1} showAnswer={true} />
      break
    case QuizType.RANKING.value:
      content = <RankingResult rank={1} name="テストユーザー" correctCount={4} time={1.0} />
      break
  }

  return (
    <div className={styles.previewDisplay}>
      <div className={styles.transformView}>{content}</div>
    </div>
  )
}

export default MobileEditorPreview
